import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const exameSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object({
    nome: Yup.string().required(v.requiredField('nome')),
    codigo: Yup.string().when('apac', {
      is: true,
      then: (schema) => schema.required(v.requiredField('codigo')),
      otherwise: (schema) => schema.notRequired(),
    }),
    tipo: Yup.string().when('apac', {
      is: true,
      then: (schema) => schema.required(v.requiredField('tipo')),
      otherwise: (schema) => schema.notRequired(),
    }),
  })
}
